'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _RUMUtil = require('../utils/RUMUtil');

var _RUMUtil2 = _interopRequireDefault(_RUMUtil);

var _utility = require('./utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-plusplus */

// videoLibrary can be overriden with a custom JS video library, if desired
// this also makes testing/mocking easier:

var HiveVideoPlayer = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(videoId, config) {
    var videoLibrary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _video2.default;

    var MAX_RETRY_COUNT, player, dmInstance, debug, plugin, retryCount, currentHiveIndex, _config$params, params, opts, _config$hiveUrls, hiveUrls, video, setSourceList, initHiveSession, handleFallback, playerPromise;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            handleFallback = function handleFallback() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

              dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[HiveVideoPlayer] fallback to CDN: ', fallbackUrls);
              _RUMUtil2.default.addError(e);
              var _config$fallbackUrls = config.fallbackUrls,
                  fallbackUrls = _config$fallbackUrls === undefined ? [] : _config$fallbackUrls;

              setSourceList(fallbackUrls);
            };

            initHiveSession = function initHiveSession(hiveUrls) {
              _RUMUtil2.default.addError('[HiveVideoPlayer] session initialization attempt: ' + retryCount);
              var url = hiveUrls[currentHiveIndex];
              dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[HiveVideoPlayer] session initialization attempt: ', url);
              plugin.initSession(url.src).then(function (session) {
                window.enableHiveXhr(plugin, player);
                setSourceList([{
                  src: session.manifest,
                  type: 'application/x-mpegURL'
                }]);
              }).catch(function (e) {
                dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[HiveVideoPlayer] session initialization error: ', e);
                if (retryCount < MAX_RETRY_COUNT) {
                  retryCount++;
                  currentHiveIndex++;
                  if (currentHiveIndex >= hiveUrls.length) {
                    currentHiveIndex = 0;
                  }
                  initHiveSession(hiveUrls);
                } else {
                  retryCount = 0;
                  handleFallback(e);
                }
              });
            };

            setSourceList = function setSourceList(urls) {
              if (!Array.isArray(urls) || (0, _lodash.isEmpty)(urls)) {
                console.warn('[HiveVideoPlayer] Invalid URLs supplied to the video player.');
                return false;
              }
              var urlList = (0, _utility.processUrls)(urls, config);
              player.src(urlList);
              dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[HiveVideoPlayer] source urls: ', urls);
              return true;
            };

            // needed for Hive xhr interceptor
            window.videojs = _video2.default;

            MAX_RETRY_COUNT = 1;
            player = videoLibrary(videoId, config);
            dmInstance = _DebugManager2.default.dmInstance;
            debug = dmInstance.debug.includes(_DebugManager2.default.debugLevel.M);
            plugin = null;
            retryCount = 0;
            currentHiveIndex = 0;
            _context.prev = 11;
            _context.next = 14;
            return (0, _utility.loadScript)('//download.hivestreaming.com/media-player/plugins/html5/8.0.0/html5.java.hivejs.hive.min.js');

          case 14:
            _context.next = 16;
            return (0, _utility.loadScript)('//download.hivestreaming.com/media-player/common_libs/html5/js/videojs/hive-videojs-xhr-interceptor.js');

          case 16:

            if (debug) {
              dmInstance.log('[HiveVideoPlayer2] config: ', config);
            }

            _config$params = config.params, params = _config$params === undefined ? {} : _config$params;
            opts = {
              debugLevel: debug ? 'debug' : 'notice',
              hiveTechOrder: ['HiveJava', 'HiveJS', 'StatsJS'],
              playerName: 'video.js',
              playerVersion: _video2.default.VERSION,
              HiveJava: {
                onActiveSession: function onActiveSession(session) {
                  dmInstance.log('HiveJava Session activated', session);
                },
                onError: function onError(error) {
                  dmInstance.log('HiveJava Error: ' + error.message);
                  _RUMUtil2.default.addError(error);
                  return true;
                }
              },
              HiveJS: {
                onActiveSession: function onActiveSession(session) {
                  dmInstance.log('HiveJS Session activated', session);
                },
                onError: function onError(error) {
                  dmInstance.log('HiveJS Error: ' + error.message);
                  _RUMUtil2.default.addError(error);
                  return true;
                },
                requestCache: {
                  queryParams: Object.keys(params)
                }
              }
            };
            _config$hiveUrls = config.hiveUrls, hiveUrls = _config$hiveUrls === undefined ? [] : _config$hiveUrls;

            (0, _utility.setupHooks)(player, config);

            if (hiveUrls.length) {
              video = player.tech().el();

              plugin = new window.HiveHtml5(video, opts);
              initHiveSession(hiveUrls);
            } else {
              handleFallback();
              _RUMUtil2.default.addError('[HiveVideoPlayer] no Hive urls present');
              dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[HiveVideoPlayer] no Hive urls present');
            }
            _context.next = 28;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context['catch'](11);

            handleFallback(_context.t0);
            console.error('[HiveVideoPlayer] Problem loading Hive libraries', _context.t0);

          case 28:
            playerPromise = new Promise(function (resolve) {
              resolve(player);
            });
            return _context.abrupt('return', playerPromise);

          case 30:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[11, 24]]);
  }));

  return function HiveVideoPlayer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = HiveVideoPlayer;